var site = site || {};
site.checkout = site.checkout || {};
(function($) {
  Drupal.behaviors.passwordTooltipIndicatorV1 = {

    attach: function(context) {
      this.context = context;
      this.initPwdValidationTooltip();
    },

    validatePwdRules: function(evt) {
      var $input = $(this);
      var value = this.value;
      var $rulesItems = evt.data.find('ul.js-password-field__rules > li');
      var $passRules = $('.js-password-field__rules', '.js-new-account');
      var rules = {
        'contains_lower_case_chars': /[a-z]/,
        'contains_uppercase_chars': /[A-Z]/,
        'contains_numbers': /[0-9]/,
        'minimum_length': /.{8,}/,
      };
      if(evt.data.find('ul.js-password-field__rules li.special_character').length > 0) {
        rules.contains_special_character = /[^\w\d|]/
      }
      evt.data.removeClass('hidden');
      // mark the input field if it has any value
      $input.toggleClass('hasValue', this.value);
      // iterate all the rules and validate them
      $.each($rulesItems, function(i, elm) {
        var valid;
        var ruleName = $(elm).data('rule');
        if (rules[ruleName]) {
          valid = rules[ruleName].test(value);
          if (ruleName === 'contains_special_character' && valid && (/[|_]/u).test(value)) {
            valid = !valid;
          }
          $(elm).toggleClass('js-pass-rules pass', valid);
        }
      });
      $('.js-password-strength-group').attr('data-strength', $passRules.find('.js-pass-rules').length);
    },

    initPwdValidationTooltip: function() {
      var isMobile = site.client.isMobile;
      var $pwdContainer = $('.js-password-field', this.context);
      var $pwdInfo = $('.js-password-field__info', $pwdContainer);
      var $pwdField;
      if (Drupal.settings && Drupal.settings.common && Drupal.settings.common.adv_legal) {
        $pwdField = $('input[type="password"]', $pwdContainer);
      } else {
        $pwdField = $('input[type="text"],input[type="password"]', $pwdContainer);
      }

      if (isMobile && !Drupal.settings.common.sign_in_up_update_password) {
        $pwdInfo.removeClass('hidden');
      }
      $pwdField.on('input focus', $pwdInfo, this.validatePwdRules);
      $pwdField.on('blur', function() {
        $pwdInfo.addClass('hidden');
        if (isMobile && !Drupal.settings.common.sign_in_up_update_password) {
          $pwdInfo.removeClass('hidden');
        }
      });
    }
  };
})(jQuery);
